(function($){
    $(function(){  //document.ready

      $('.faq_wapper .faq_box').on('click', function(){
        $(this).hasClass('active');
         $('.faq_wapper .faq_box').removeClass('active');
         $(this).addClass('active');
      });
      
      $('.contact_form_touch .content-block .snd_us .btn').prop('value', 'Send Us A Message');
      
      
     
        $('a.article-block').prop("href", "https://www.aqueendom.com/pages/landing-page");    
      
$('.lanidng_pro .main_product_wrapper .collection .grid__item:nth-child(1) .product-card a').prop("href", "https://www.facebook.com/marketplace/item/515927999748084/");
$('.lanidng_pro .main_product_wrapper .collection .grid__item:nth-child(1) .product-card__price').text("On sale from $24");      
      
 $('.lanidng_pro .main_product_wrapper .collection .grid__item:nth-child(2) .product-card a').prop("href", "https://www.facebook.com/marketplace/item/515927999748084/");
 $('.lanidng_pro .main_product_wrapper .collection .grid__item:nth-child(2) .product-card__price').text("On sale from $24"); 
      
      
 $('.lanidng_pro .main_product_wrapper .collection .grid__item:nth-child(3) .product-card a').prop("href", "https://www.facebook.com/marketplace/item/3705389289547839/");
 $('.lanidng_pro .main_product_wrapper .collection .grid__item:nth-child(3) .product-card__price').text("On sale from $24"); 
      
 $('.lanidng_pro .main_product_wrapper .collection .grid__item:nth-child(7) .product-card a').prop("href", "https://www.facebook.com/marketplace/item/428283698416743/");
 $('.lanidng_pro .main_product_wrapper .collection .grid__item:nth-child(7) .product-card__price').text("On sale from $24");     
 
      
});
  
  


})(jQuery);